import { getCurrentUserSiteMemberId } from '@wix/communities-blog-client-common';
import { getIsInIFrame } from '../../../common/selectors/is-in-iframe';

export const getViewedUserSiteMemberId = (state) => {
  if (getIsInIFrame(state)) {
    return getCurrentUserSiteMemberId(state);
  }
  return state.viewedUser;
};
